import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { useSignUpQueryParams } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpQueryParams";
import { useIsAppRouterMigration } from "@faire/retailer-visitor-shared/views/SignUp/_utils/useIsAppRouterMigration";
import {
  Step,
  stepKeyToPathMap,
} from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import { useEffect } from "react";

const stepKeyToPrefetchMap: Partial<Record<Step, Step[]>> = {
  [Step.PERSONAL_INFO]: [Step.BUSINESS_TYPE],
  [Step.BUSINESS_TYPE]: [Step.STORE_INFO],
  [Step.STORE_INFO]: [Step.OPENING_YEAR, Step.STORE_TYPE_S1],
};

export const useSignUpPrefetchEffect = (step: Step) => {
  const isAppRouterMigration = useIsAppRouterMigration();
  const { prefetch: nextPrefetch } = useNextRouterContext();
  const { queryParams } = useSignUpQueryParams();

  useEffect(() => {
    if (isAppRouterMigration) {
      const nextSteps = stepKeyToPrefetchMap[step];
      if (nextSteps) {
        nextSteps.forEach((nextStep) => {
          nextPrefetch(stepKeyToPathMap[nextStep](queryParams), {
            kind: PrefetchKind.FULL,
          });
        });
      }
    }
  }, [nextPrefetch, queryParams, step, isAppRouterMigration]);
};
